import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";


import {
  SiJavascript,
  SiMui,
  SiReact,
  SiTailwindcss,
  //SiFigma,
  //SiAdobexd,
  //SiAdobephotoshop,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
 // SiWordpress,
  SiFirebase,
 // SiDocker,
  SiExpress,
 // SiNginx,
 // SiAngular,
 SiPython,
 SiC,SiNumpy,SiPandas,SiScikitlearn,SiKeras,SiTensorflow
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS ",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "TypeScript",
    icon: SiTypescript,
  },
  // {
  //   _id: 6,
  //   name: "Angular",
  //   icon: SiAngular,
  // },
  {
    _id: 6,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 7,
    name: "Nextjs",
    icon: TbBrandNextjs,
  },
  {
    _id: 8,
    name: "React MUI",
    icon: SiMui,
  },
  {
    _id: 9,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },
  // {
  //   _id: 10,
  //   name: "Figma ",
  //   icon: SiFigma,
  // },
  // {
  //   _id: 12,
  //   name: "Adobe XD ",
  //   icon: SiAdobexd,
  // },
  // {
  //   _id: 13,
  //   name: "Photoshop ",
  //   icon: SiAdobephotoshop,
  // },
  {
    _id: 11,
    name: "React Native ",
    icon: SiReact,
  },
  {
    _id: 12,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 13,
    name: "Express JS ",
    icon: SiExpress,
  },
  // {
  //   _id: 17,
  //   name: "Wordpress ",
  //   icon: SiWordpress,
  // },
  {
    _id: 14,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 15,
    name: "SQL ",
    icon: SiMysql,
  },
  {
    _id: 16,
    name: "Firebase ",
    icon: SiFirebase,
  },
  {
    _id: 17,
    name: "Git / Github ",
    icon: SiGithub,
  },
  // {
  //   _id: 22,
  //   name: "Docker ",
  //   icon: SiDocker,
  // },
  // {
  //   _id: 23,
  //   name: "Nginx ",
  //   icon: SiNginx,
  // },
  {
    _id: 18,
    name: "Python",
    icon: SiPython,
  },
  {
    _id: 19,
    name: "C",
    icon: SiC,
  }
  ,
  {
    _id: 20,
    name: "Numpy",
    icon: SiNumpy,
  },
  {
    _id: 21,
    name: "Pandas",
    icon: SiPandas,
  },
  {
    _id: 22,
    name: "Scikit-learn",
    icon: SiScikitlearn,
  },
  {
    _id: 23,
    name: "Keras",
    icon: SiKeras,
  },
  {
    _id: 24,
    name: "TensorFlow",
    icon: SiTensorflow,
  }
 
  
];
export default TechstackList;
